<!--  <ProductStageMeter :inline="true" /> to get the label in line with the meter -->

<template>
  <div class="list-item-stage" :class="{ inline }">
    <div class="meter" :class="meterClass">
      <i></i><i></i><i></i><i></i><i></i>
    </div>
    <div v-if="showLabel" class="stage-text">
      {{ getStageLabel(stage) }}
    </div>
  </div>
</template>

<script>
import { getStageLabel } from '@/services/startup-stages'

export default {
  props: {
    stage: String,
    inline: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    meterClass() {
      return {
        idea: 'meter0',
        pre_seed: 'meter1',
        seed: 'meter2',
        early_growth: 'meter3',
        growth: 'meter4',
        maturity: 'meter5',
      }[this.stage]
    },
  },
  methods: { getStageLabel },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.list-item-stage.inline {
  margin-top: 0px;
  display: flex;
  flex-direction: row;

  .stage-text {
    margin: 0 10px;
    order: 1;
    font-weight: bold;
  }

  .meter {
    order: 2;
    margin: 7px 0 0 0;
    left: 0;
  }
}

.list-item-stage {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 8px;

  .stage-text {
    margin: 8px 0px;
  }
}

.meter {
  display: block;
  border-radius: 12px;
  width: 50px;
  height: 6px;
  background: $grey150;
  padding: 0;
  margin: 0;
  position: relative;

  i {
    width: 16.6%;
    border-right: 1px solid $white;
    display: block;
    float: left;
    height: 6px;
    position: relative;
    z-index: 20;
  }

  &.meter0 {
    background: linear-gradient(90deg, #bb4e7e 16%, $grey150 16%);
  }
  &.meter1 {
    background: linear-gradient(90deg, #fdba74 33.2%, $grey150 33.2%);
  }
  &.meter2 {
    background: linear-gradient(90deg, #fde047 49.8%, $grey150 49.8%);
  }
  &.meter3 {
    background: linear-gradient(90deg, #c6f093 66.4%, $grey150 66.4%);
  }
  &.meter4 {
    background: linear-gradient(90deg, #76ca32 82%, $grey150 82%);
  }
  &.meter5 {
    background: #46b966;
  }
}
</style>
